export default __webpack_public_path__ + "static/media/bitmap_logo.2bb68473.png";